import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/电影" },
  { label: "电视剧", to: "/category/电视剧" },
  { label: "专题", to: "/special/s1" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : "/search");
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur-md">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex h-16 items-center justify-between gap-4 md:h-[72px]">
          <Link to="/" className="flex shrink-0 items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-sparkling-2-fill text-lg" />
            </span>
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950 md:text-xl">
              妖精网站
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2 text-sm font-medium transition-colors lg:px-4 ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                  }`
                }
                end={item.to === "/" || item.to === "/special/s1"}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form
            onSubmit={handleSearch}
            className="hidden items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4 py-2 lg:flex"
          >
            <i className="ri-search-line text-base text-foreground-500" />
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索妖精影视作品"
              className="w-40 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500 xl:w-56"
            />
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              搜索
            </button>
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>

        {menuOpen && (
          <div className="border-t border-background-200 py-4 md:hidden">
            <form
              onSubmit={handleSearch}
              className="mb-3 flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4 py-2"
            >
              <i className="ri-search-line text-base text-foreground-500" />
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索妖精影视作品"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
              />
              <button
                type="submit"
                className="whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50"
              >
                搜索
              </button>
            </form>
            <nav className="flex flex-col">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                      isActive
                        ? "bg-primary-100 text-primary-700"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                  end={item.to === "/" || item.to === "/special/s1"}
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}